import { config as hopsConfig } from '@xingternal/hops';

export const isDevelopment = () => hopsConfig.nodeEnv !== 'production';

export const isProduction = () => hopsConfig.appEnv === 'production';
export const isPreview = () => hopsConfig.appEnv === 'preview';
